import { cva } from 'class-variance-authority';
import React from 'react';
import { cn } from '../../lib/cn';

const typeVariants = cva('text flex !my-0', {
  variants: {
    size: {
      xxs: 'text-xs',
      xs: 'text-xs',
      sm: 'text-xs md:text-sm',
      base: 'text-sm md:text-base',
      lg: 'text-base md:text-lg',
      xl: 'text-lg md:text-xl',
    },
    textColor: {
      primary: 'text-foreground',
      secondary: 'text-muted-foreground',
      surface: 'text-surface-foreground',
      white: 'text-white',
    },
    weight: {
      regular: 'font-normal',
      medium: 'font-medium',
      bold: 'font-semibold',
    },
  },
  defaultVariants: {
    size: 'sm',
    textColor: 'primary',
    weight: 'regular',
  },
});

const Type = React.forwardRef(({ className, size, textColor, weight, ...props }, ref) => (
  <p className={cn(typeVariants({ size, textColor, weight }), className)} ref={ref} {...props} />
));
Type.displayName = 'Type';

export { Type };
